export default "__VITE_ASSET__CAFzMYFJ__"